module.exports = __webpack_public_path__ + "img/login-v2.63de4cc7.svg";